<template>
  <div>
    <Modal :footer-hide="true" :mask-closable="false" v-model="show" :title="row.name" :width="1000" @on-cancel="clearForm()">
      <table class="QHtable" v-if="!$isblank(row)">
        <tr>
          <th style="width: 125px">单位信息</th>
          <th></th>
        </tr>
        <tr>
          <td><b>排放单位</b></td>
          <td>{{ row.name }}</td>
        </tr>
        <tr>
          <td><b>通讯地址</b></td>
          <td>{{ row.addressFull }}</td>
        </tr>
        <tr>
          <td><b>联系姓名</b></td>
          <td>{{ row.contactName }}</td>
        </tr>
        <tr>
          <td><b>联系电话</b></td>
          <td>{{ row.contactTel }}</td>
        </tr>

        <!---资质-->
        <tr v-for="(item, index) in row.orgAllQualification" :key="index">
          <td>
            <b>{{ $s("zizhiTypeTxt", item.zizhiType) || "其他资质" }}</b>
          </td>
          <td>
            <div class="flex-between">
              <div>
                <span class="MR5 CL4" v-if="$isYouxiaoqiNei(item.startTime, item.endTime)"><i class="MR3 iconfont icon-tongyi"></i>有效期内</span>
                <span class="MR5 CL6" v-else><i class="MR3 iconfont icon-wenhao-quan"></i>有效期外</span>
                <span>{{ item.name }}</span>
                <span style="white-space: nowrap">(有效期{{ $timeFmt(item.startTime, "YYYY年MM月DD日") }}至{{ $timeFmt(item.endTime, "YYYY年MM月DD日") }})</span>
              </div>
              <div class="flex-between" style="margin-left: 10px">
                <span class="QHset" style="white-space: nowrap" @click="$openImg($getFritImg(item.url))"> 查看 </span>
              </div>
            </div>
          </td>
        </tr>
        <!---资质 end-->
      </table>
    </Modal>

  </div>
</template>
<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      show: false,
      isUpdate: false,
      row: {},
    };
  },
  methods: {
    // +----------------------------------------------------------------------
    // | Desc:弹窗详情
    // +----------------------------------------------------------------------
    hiPop(e) {
      //参数整合与接口
      var that = this;
      var https = {
        type: "isRow",
        api: this.$api.getOrglinshizhongzhuanDetailed,
        parameter: {
          id: e.id,
        },
      };
      this.$httpsApi(https, function (res) {
        that.title = res.data.name;
        that.show = true;
      });
    },

    // +----------------------------------------------------------------------
    // | Desc:刷新详情
    // +----------------------------------------------------------------------
    reDetailed() {
      this.hiPop(this.row);
      this.isUpdate = true;
    },

    // +----------------------------------------------------------------------
    // | Desc:清理关闭
    // +----------------------------------------------------------------------
    clearForm() {
      this.show = false;
      this.row = {};
      if (this.isUpdate) {
        this.$emit("success");
        this.isUpdate = false;
      }
    },
  },
};
</script>
